export default "__VITE_ASSET__B4zb8P$J__"